module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-12.8b3c76b7.png";